import "./QuestionButton.css";
import React, { useState, useEffect } from "react";

interface QuestionButtonProps {
    listText: string;
    questionText: string;
    buttonHandler?: (questionText: string) => void;
    load?: boolean; // To handle loading state
    isPress?: boolean; // To manage button disable state from the parent
    color?: string; // To set the color of the text
    fontWeight?: string; // To set the font weight of the text
    floatingWidgetState?: string;
}

const wrapBoldInColorTags = (text: string, color: string, fontWeight: string): React.ReactNode => {
  const regex = /<color>(.*?)<\/color>/g;
  if (!regex.test(text)) {
    return text;
  }

  const parts = text.split(regex);
  return parts.map((part, index) => {
    if (regex.test(`<color>${part}</color>`)) {
      return (
        <span
          key={index}
          style={{
            fontWeight: fontWeight,
            color: color,
          }}
        >
          {part}
        </span>
      );
    }
    return part;
  });
};

export const QuestionButton: React.FC<QuestionButtonProps> = ({ listText, questionText, buttonHandler, load, isPress, color = "rgba(0, 110, 168, 1)", fontWeight = "bold",floatingWidgetState = null }) => {
    const [isPressed, setIsPressed] = useState(false);
    useEffect(() => {
        if (isPress) {
            setIsPressed(true); // Disable the button if isPress is true
        } else {
            setIsPressed(false); // Re-enable if isPress is false
        }
    }, [isPress]);

    const handleClick = () => {
        if (!isPressed && buttonHandler && !load) {
            // Call the button handler with the question text
            buttonHandler(questionText);
            // Disable the button after press
            setIsPressed(true);
        }
    };

    return (
        <article
            className={`questionButton__container ${floatingWidgetState ? floatingWidgetState : ''} ${isPressed ? 'disabled' : ''}`}
            onClick={handleClick}
        >
            <div className="questionButton__mark"><p>{listText}</p></div>
            <div className={`questionButton__text ${floatingWidgetState ? floatingWidgetState : ''}`}>{wrapBoldInColorTags(questionText, color, fontWeight)}</div>
        </article>
    );
};